export const msalConfig = {
  auth: {
    clientId: "0777cf78-0915-4049-9302-2ea833ede808",
    authority: "https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1/v2.0/",
    redirectUri: "https://portal.oi.rabobank.nl",
  },
};

export const loginRequest = {
  scopes: ["https://portal2prd.oi.rabobank.nl/user_impersonation"], 
};
